import type { ComponentChildren } from "preact";
import type { PageContent } from "../content/index.js";
import { MessageIcon } from "../shared/icons.js";
import { whatsappHref } from "../shared/links.js";

export interface HeroProps {
  readonly content: PageContent;
  readonly aside?: ComponentChildren;
}

export function Hero({ content, aside }: HeroProps) {
  const [first, second, third] = content.hero.title;
  const text = (
    <>
      <p class="micro on-photo">{content.hero.kicker}</p>
      <h1 class="hero-title">
        {first}
        <br />
        {second}
        <em>{third}</em>
      </h1>
      <p class="hero-sub">{content.hero.sub}</p>
      <div class="hero-actions">
        <a class="pill pill-photo" href={content.hero.ctaHref ?? whatsappHref(content)}>
          {content.hero.ctaHref ? null : <MessageIcon size={18} />}
          {content.hero.cta}
        </a>
        <a class="hero-alt" href={content.hero.altHref ?? "#como"}>
          {content.hero.alt}
        </a>
      </div>
    </>
  );
  return (
    <header class="hero" id="top">
      <img
        class="hero-photo"
        src="/assets/photos/hero-pista.webp"
        alt={content.meta.photoAlt.hero}
        width={1024}
        height={576}
        fetchpriority="high"
      />
      {(content.hero.slides ?? []).map((src, index) => (
        <img
          key={src}
          class="hero-photo hero-slide"
          src={src}
          alt=""
          aria-hidden="true"
          width={1024}
          height={576}
          fetchpriority="low"
          style={`--slide:${index + 1}`}
        />
      ))}
      <span class="hero-veil" aria-hidden="true" />
      {aside ? (
        <div class="hero-body wrap has-aside">
          <div class="hero-main">{text}</div>
          {aside}
        </div>
      ) : (
        <div class="hero-body wrap">{text}</div>
      )}
    </header>
  );
}
